import React from 'react'

import { Redirect } from 'react-router-dom'
import utils from '../../Utils'
import SnackBar from 'components/SnackBar'
import { TextMessage, ImageMessage, AudioMessage, VideoMessage, ApplicationMessage } from './TextMessage'
import Loading from 'components/Loading'
import ModalImageViewer from 'components/ModalImageViewer'
import 'style/Chat.css'
import Header from 'components/Header'
import Matrix from 'scripts/Matrix'
import sdk from "matrix-js-sdk"
import RecorderService from '../../scripts/RecorderService'
import StarRatingComponent from 'react-star-rating-component';
import StarRoundedIcon from '@material-ui/icons/StarRounded';
import AttachFileRoundedIcon from '@material-ui/icons/AttachFileRounded';
import imageCompression from 'browser-image-compression'

import ModalMenu from '../ModalMenu'
import ModalLockRoom from './ModalLockRoom'




// import axios from 'axios';
import Add from '@material-ui/icons/Add';
import Mic from '@material-ui/icons/Mic';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import FiberManualRecordRoundedIcon from '@material-ui/icons/FiberManualRecordRounded';
import MicRoundedIcon from '@material-ui/icons/MicRounded';
import SendIcon from '@material-ui/icons/Send';
import HistoryRoundedIcon from '@material-ui/icons/HistoryRounded';
import AssignmentTurnedInRoundedIcon from '@material-ui/icons/AssignmentTurnedInRounded';
import LockRoundedIcon from '@material-ui/icons/LockRounded';
import ModalRater from '../ModalRater'
const matrixBaseUrl = 'https://msg.tebinja.com';

export default class Chat extends React.Component {
  constructor(props) {
    super(props)
    this.chiz = false
    this.intervalId = 0
    this.humanDateGlobal = null
    this.state = {
      title: props.location.title,
      client: props.location.client,
      userId: Matrix.getUserId(),
      room_id: props.match.params.id,
      accessToken: Matrix.getAccessToken(),
      nextSyncToken: props.location.nextSyncToken,
      isFirstGet: true,
      loading: false,
      initLoading: true,
      data: [],
      message: undefined,
      isLastPage: false,
      currentRoom: undefined,
      timelineWindow: undefined,
      recording: false,
      secondRecorded: 0,
      isDeleteRecordingPressed: false,
      uploadAudioLoading: false,
      hasMore: true,
      roomStatus: undefined,
      redirectTo: '',
      menus: [],
      hasScroll: false,
      mainMember: null,
      imageLoading: false,
      date: null,
      modalLockRoom: null,
      isVoiceClicked: false
    }
  }

  startRecording = () => {
    this.recorderSrvc.config.stopTracksAndCloseCtxWhenFinished = true
    this.recorderSrvc.config.createDynamicsCompressorNode = false
    this.recorderSrvc.config.enableEchoCancellation = true
    this.recorderSrvc.startRecording()
      .then(() => {
        this.setState({ recording: true })
        this.intervalId = setInterval(() => {
          this.setState({ secondRecorded: this.state.secondRecorded + 1 })
        }, 1000)
      })
      .catch((error) => {
        console.error('Exception while start recording: ' + error)

      })
  }
  humanReadable = (second) => {
    let mydate = new Date(second * 1000);
    return this.convertTo2Digit(mydate.getUTCMinutes()) + ':' + this.convertTo2Digit(mydate.getUTCSeconds())
  }
  convertTo2Digit(num) {
    if (num < 10) return '0' + num
    return num
  }
  stopRecording = () => {
    this.recorderSrvc.stopRecording()
    this.setState({ secondRecorded: 0 })
    clearInterval(this.intervalId)
  }
  deleteRecording = () => {
    this.setState({ isDeleteRecordingPressed: true })
    this.stopRecording()
  }
  sendRecording = () => {
    this.setState({ isDeleteRecordingPressed: false })
    this.stopRecording()
  }
  onNewRecording = async (evt) => {
    if (this.state.isDeleteRecordingPressed) {
      URL.revokeObjectURL(evt.detail.recording.blobUrl)
      this.setState({ recording: false })
      return
    }
    this.setState({ uploadAudioLoading: true })
    // console.log(evt, '----------------')
    // let stream = fs.createReadStream();
    console.log(evt.detail.recording)
    let uploadedContent = await this.state.client.uploadContent(evt.detail.recording.blob)
    URL.revokeObjectURL(evt.detail.recording.blobUrl)
    await this.sendAudioMessage(uploadedContent)
    this.setState({ uploadAudioLoading: false, recording: false })
    // console.log(this.state.client.mxcUrlToHttp(uploadedContent))
    this.scrollToBottom()

  }

  lockChat = async () => {
    const result = await utils.iaxios({
      method: 'PATCH',
      url: utils.urls.lockRoomUrl,
      data: { consultRequestId: this.state.roomStatus.consultRequest.id }
    }, true)
      .catch(e => {
        const message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.SnackBar.openSnackbar(message)
      })

    if (!result) return

    const { success } = result.data
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

    this.setState((prevState) => {
      const roomStatus = { ...prevState.roomStatus }
      roomStatus.status = 'closed'
      roomStatus.consultRequest.status = 'closed'
      roomStatus.consultRequest.roomStatus = 'closed'

      return { roomStatus: roomStatus }
    })
  }

  sendBtn = () => {
    (this.state.roomStatus.consultRequest.status === 'pre-closed') ? this.modalLockRoom.openModal(this.sendMessage) : this.sendMessage()
  }

  sendAudioMessage = async (url) => {
    if (this.state.roomStatus.consultRequest.status === 'pre-closed') this.lockChat()

    let content = {
      url: url,
      msgtype: 'm.audio',
      info: {
        "mimetype": "audio/mpeg"
      },
      body: 'voice.mp3'
    };
    let sentMessage = await this.state.client.sendMessage(this.state.room_id, content);
    // console.log(sentMessage)

  }
  async init() {
    let client = await Matrix.login()
    this.setState({ client: client })
    const { title, isGroup, mainMember } = utils.initRoomNameAndMember(client.getRoom(this.state.room_id), Matrix.getUserId())
    this.setState({ title: title, mainMember })
    // if(mainMember)
    let _this = this;
    client.on('Room.timeline', this.onRoomTimeline);

    // client.startClient();
  }
  onRoomTimeline = (event, state, toStartOfTimeline) => {
    // console.log('clientclient', event)
    if (event.event.type == 'm.room.message' && event.event.room_id == this.state.room_id) {
      this.newMessage(event, toStartOfTimeline)
    }
  }

  componentWillUnmount() {
    this.state.client.removeListener('Room.timeline', this.onRoomTimeline)
  }

  getLastEvent = (room) => {
    const timeline = room.getLiveTimeline();
    const events = timeline.getEvents();
    if (events.length) {
      const lastEvent = events[events.length - 1];
      return lastEvent;
    } else {
      return null;
    }
  };

  newMessage(event, toStartOfTimeline) {
    // let { client, room_id, accessToken, message } = this.state;
    let { data } = this.state;
    // console.log('newMessage event: ', event);


    // console.log('newMessage: ', event.event);
    try {
      // if (event.content.msgtype == 'm.audio') {
      //   console.log(event)
      // }

      // let newMessage = event.event;
      if (!toStartOfTimeline) {
        data.unshift(event)
        // let owner = newMessage.sender === this.state.userId || newMessage.user_id === this.state.userId // if it was me
        // if (owner) this.scrollToBottom()
      }
      else
        data.push(event)
      // console.log('data : ', data);



      this.setState({
        data: data,
      });

      // this.textInput.clear();
      // this.setState({
      //   message: ''
      // });
    } catch (e) {
      console.log(e);
    }
  }

  onTextInputHandle = (event) => {
    const textarea = this.refs.textInput
    if (textarea.scrollHeight < 100) {
      textarea.style.height = 0 // has to set to 0 for shrinking
      textarea.style.height = textarea.scrollHeight + 'px'
    }
    this.setState({ message: event.target.value })
  }

  sendMessage = async (e) => {
    let { client, room_id, accessToken, message } = this.state;
    message = message.trim()
    client = await Matrix.login()

    if (this.state.roomStatus.consultRequest.status === 'pre-closed') this.lockChat()

    if (this.state.message && message) {
      try {
        //   let content = {
        //     msgtype: 'm.text',
        //     body: message
        //   };
        let sentMessage = await client.sendTextMessage(room_id, message);
        // console.log(sentMessage, ' sent message ');

        // let url = `${matrixBaseUrl}/_matrix/client/r0/rooms/${room_id}/read_markers?access_token=${accessToken}`;
        // axios.post(url, {
        //   'm.fully_read': sentMessage.event_id
        // });


        this.refs.textInput.value = ''
        this.refs.textInput.style.height = 'inherit'
        this.setState({ message: '' });
        this.scrollToBottom()

      } catch (e) {
        console.log(e);
      }
    }
  }



  async roomMessage() {
    let client = await Matrix.login()
    const currentRoom = client.getRoom(this.state.room_id)
    this.setState({ currentRoom: currentRoom })
    currentRoom.timeline.forEach(event => {
      if (event.event.content.msgtype == 'm.audio') {
      }
      // console.log('...............', event)
      this.setState({ data: [event, ...this.state.data] })
    })

    this.setState({ initLoading: false })
    const timeLineWindow = new sdk.TimelineWindow(client, currentRoom.getUnfilteredTimelineSet(), { windowLimit: 20 })

    this.setState({ timelineWindow: timeLineWindow })
    await timeLineWindow.load()

    // await timeLineWindow.paginate(sdk.EventTimeline.BACKWARDS,20)
  }

  // async getRoomMessages() {
  //   // this.roomMessage()
  //   let { room_id, nextSyncToken, accessToken, isFirstGet } = this.state;
  //   const accessTokens = Matrix.getAccessToken()
  //   try {
  //     let allMessages = matrixBaseUrl + `/_matrix/client/r0/rooms/${room_id}/messages?limit=10000&access_token=${accessTokens}&dir=b`;
  //     let result = await axios.get(allMessages);
  //     // console.log('F*CK', nextSyncToken === result.data.end, nextSyncToken, result.data.end, result)
  //     if (nextSyncToken === result.data.end) {
  //       this.setState({
  //         loading: false,
  //         isLastPage: true,
  //       });
  //       return;
  //     }

  //     if (result.data.chunk.length > 0) {
  //       this.setState(prevState => {
  //         return {
  //           data: isFirstGet ? result.data.chunk : [...prevState.data, ...result.data.chunk],
  //           loading: false,
  //           nextSyncToken: result.data.end,
  //         }
  //       })
  //     }
  //   } catch (error) {
  //     // console.log(error);
  //   }
  // };



  loadMoreMessage = async () => {
    if (this.state.loading) return
    if (this.state.timelineWindow) {
      if (this.state.timelineWindow.canPaginate(sdk.EventTimeline.BACKWARDS)) {
        this.setState({ loading: true, hasMore: true })
        await this.state.timelineWindow.paginate(sdk.EventTimeline.BACKWARDS, 20, true, 1)
        this.setState({ loading: false })
      } else {
        this.setState({ hasMore: false })

      }

    }
  }

  roomStatus = async () => {

    let result = await utils.iaxios({
      method: 'get',
      url: utils.urls.roomStatusURL + `?roomId=${this.state.room_id}`,

    }, true)
      // let result = await axios.get(utils.urls.roomStatusURL + `?roomId=${this.state.room_id}`, {
      //   headers: {
      //     'x-access-token': Matrix.getToken()
      //   }
      // })
      .catch((e) => {
        console.log(e.response)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.SnackBar.openSnackbar(message)
      });
    // this.setState({ loading: false })

    if (!result) return
    // console.log(result, '###############')

    let { success, roomStatus } = result.data;
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

    this.setState({ roomStatus })


  }

  gotoConsultHistory = () => {
    // console.log('in callback of showquiz--------------------', this.state)
    if (this.state.roomStatus &&
      this.state.roomStatus.consultRequest &&
      this.state.roomStatus.consultRequest.id)
      this.setState({ redirectTo: '/consultHistory/' + this.state.roomStatus.consultRequest.id })

  }
  handleLoadMore = () => {
    if (this.state.data.length > 0 && (!this.state.isLastPage)) {
      this.setState({ loading: true, isFirstGet: false }, () => {
        this.getRoomMessages()
      })
    }
  }

  async componentDidMount() {
    // this.refs.psudo.addEventListener('scroll', this.handleScroll);
    await this.init();
    // this.getRoomMessages();
    await this.roomMessage()
    // window.scrollTo(100, document.body.scrollHeight);
    this.scrollToBottom()
    this.roomStatus()
    // this.state.client.setRoomReadMarkers(this.state.room_id, this.state.currentRoom.timeline[0].getId(), this.state.currentRoom.timeline[0], {hidden: false})
    this.state.client.sendReceipt(this.getLastEvent(this.state.currentRoom), "m.read")

    this.state.currentRoom.setUnreadNotificationCount('total', 0)
    this.recorderSrvc = new RecorderService()
    this.recorderSrvc.em.addEventListener('recording', (evt) => this.onNewRecording(evt))

    this.setState({ hasMore: this.state.timelineWindow.canPaginate(sdk.EventTimeline.BACKWARDS) })


  }




  handleScroll = async (e) => {
    let element = e.target

    if (!this.state.hasScroll && element.scrollHeight - element.clientHeight > 300) this.setState({ hasScroll: true })
    // if (this.chiz) return
    if (this.state.loading) {
      // console.log('loading is true....')
      return
    }
    // console.log(element.scrollHeight, element.clientHeight)
    if (element.scrollTop < 300 && element.scrollTop > 100 && this.state.hasMore) {
      // this.chiz = true

      // this.setState({ loading: true })
      // console.log(element.scrollTop)
      await this.loadMoreMessage()
      // console.log('------------------------------------------------------- ========================================================')
      // element.scrollTop+=100
    }
    // if(element.sc)
  }


  textareaResize(e) {
    e.target.style.height = 'inherit';
    e.target.style.height = `${e.target.scrollHeight}px`;
  }
  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView();
  }

  onSubmitRate = async (rate) => {
    if (rate < 1) return this.SnackBar.openSnackbar('ابتدا مقداری اتنخاب نمایید')
    let result = await utils.iaxios({
      method: 'post',
      url: utils.urls.roomRateURL,
      data: { rate, roomId: this.state.room_id }
    }, true)
      // let result = await axios.post(utils.urls.roomRateURL, { rate, roomId: this.state.room_id }, {
      //   headers: {
      //     'x-access-token': Matrix.getToken()
      //   }
      // })
      .catch((e) => {
        console.log(e.response)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.SnackBar.openSnackbar(message)
      });
    // this.setState({ loading: false })

    if (!result) return
    // console.log(result, '###############')

    let { success, rateroom } = result.data;
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

    this.setState({ roomStatus: { ...this.state.roomStatus, roomConversationRate: rateroom } })
  }

  voiceBtnAction = () => {
    (this.state.roomStatus.consultRequest.status === 'pre-closed') ? this.modalLockRoom.openModal(this.startRecording) : this.startRecording()
  }

  renderMainElement(item, index) {
    let element
    let owner = item.getSender() === this.state.userId // if it was me
    if (item.getContent().msgtype === 'm.text') {
      element = <TextMessage text={item.getContent().body} me={owner} time={item.getTs()}></TextMessage>;
    }
    else if (item.getContent().msgtype === 'm.image') {
      element = <ImageMessage src={this.state.client.mxcUrlToHttp(item.getContent().url)} me={owner} showImageModal={this.showImageModal}></ImageMessage>
    } else if (item.getContent().msgtype === 'm.audio') {
      element = (
        <AudioMessage
          audioUrl={this.state.client.mxcUrlToHttp(item.getContent().url)}
          me={owner}
          duration={item.getContent().info ? item.getContent().info.duration : 0}
        />
      )
    } else if (item.getContent().msgtype === 'm.application') {
      console.log(item)
      element = <ApplicationMessage me={owner} time={item.getTs()} title={item.getContent().body} src={this.state.client.mxcUrlToHttp(item.getContent().url)} />
    } else if (item.getContent().msgtype === 'm.video') {
      element = <VideoMessage src={this.state.client.mxcUrlToHttp(item.getContent().url)} me={owner} time={item.getTs()} />
    } else if (item.getContent().membership === 'join' && item.getContent().displayname.includes('_')) {
      let msg = ' به گفتگو پیوست'
      if (item.getPrevContent().membership === 'join') {
        msg = ' به روز رسانی شد'
      }
      element = <div class='center'>{utils.roomMemberDisplayName({ name: item.getContent().displayname })} {msg}</div>
    }
    if (element) return <div class="MessageRow" key={item.getId()}>{element}</div>
  }

  renderDateElement(item, index) {
    if (index + 1 === this.state.data.length) {
      this.humanDateGlobal = utils.timeStampToDDMM(item.getTs())
      return <div class="MessageRow" key={'date' + item.getId()}><div style={{ fontSize: 12, alignSelf: 'center', textAlign: 'center', background: '#fff9', padding: '5px 30px', borderRadius: '23px', margin: '5px 0 10px 0', direction: 'rtl' }}>{this.humanDateGlobal}</div></div>
    }
    let shouldShowDate = false
    let humanDate = utils.timeStampToDDMM(item.getTs())
    if (!this.humanDateGlobal) this.humanDateGlobal = humanDate
    else if (this.humanDateGlobal !== humanDate) shouldShowDate = true
    if (shouldShowDate) {
      let eledate = <div class="MessageRow" key={'date' + item.getId()}><div style={{ fontSize: 12, alignSelf: 'center', textAlign: 'center', background: '#fff9', padding: '5px 30px', borderRadius: '23px', margin: '5px 0 10px 0', direction: 'rtl' }}>{this.humanDateGlobal}</div></div>
      this.humanDateGlobal = humanDate
      return eledate
    }
  }
  renderItem(item, index) {
    if ((index + 1 === this.state.data.length) && item.getType() !== 'm.room.message') return this.renderDateElement(item, index)
    if (item.getType() == 'm.room.message' || (item.getType() === 'm.room.member' && item.getContent().membership === 'join')) {
      let element = this.renderMainElement(item, index)
      let dateElement = this.renderDateElement(item, index)
      return (
        <>
          {dateElement || ''}
          {element}
        </>
      )
    }

  };

  async compressImage(event, useWebWorker) {
    const file = event.target.files[0]
    console.log('input', file)
    const targetName = useWebWorker ? 'webWorker' : 'mainThread'
    console.log({ inputSize: (file.size / 1024 / 1024).toFixed(2) })
    var options = {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 1920,
      useWebWorker,
      //onProgress: p => this.onProgress(p, useWebWorker)
    }
    const output = await imageCompression(file, options)
    console.log({ outputSize: (output.size / 1024 / 1024).toFixed(2) })
    return output;
  }

  onChangeHandler = async (event) => {
    const file = event.target.files[0]
    console.log(file)
    // const data = await this.toBase64(file)
    // let uploadedContent = await this.state.client.uploadContent(file)
    this.setState({ imageLoading: true })

    if (file.type && file.type.includes('image')) {
      const compressedImage = await this.compressImage(event, false)
      let uploadedContent = await this.state.client.uploadContent(compressedImage)
      await this.state.client.sendImageMessage(this.state.room_id, uploadedContent);
      // await this.state.client.sendImageMessage(this.state.room_id, uploadedContent);
    } else {
      let uploadedContent = await this.state.client.uploadContent(file)
      await this.sendContentMessage(file, uploadedContent)
    }
    this.setState({ imageLoading: false })
  }

  sendContentMessage = async (file, url) => {
    if (!url || !file) return
    let msgtype
    let type
    if (file && file.type) {
      let types = file.type.split('/')
      if (types[1]) type = types[1]
      if (types[0]) msgtype = 'm.' + types[0]
      else msgtype = 'm.application'
    } else msgtype = 'm.application'
    let content = {
      url: url,
      msgtype: msgtype,
      info: {
        "mimetype": file.type
      },
      body: (file && file.name) || 'File'
    }
    console.log(content, 'here is the content body')
    let sentMessage = await this.state.client.sendMessage(this.state.room_id, content);
  }


  showImageModal = (imageSrc) => {
    this.modalImageViewer.openModal(imageSrc)
  }
  showModalMenu = () => {
    console.log('gggggggggggggggggg')
    if (this.state.menus && this.state.menus.length > 0)
      this.modalMenu.openModal()
  }

  openSnackbar = (msg, info) => this.SnackBar.openSnackbar(msg, info)

  render() {
    if (this.state.redirectTo) {
      return <Redirect push to={this.state.redirectTo}></Redirect>
    }
    return (
      <React.Fragment>
        <div class="chatRoot">
          <div class='background'></div>
          <Header
            doctorId={this.state.roomStatus && this.state.roomStatus.consultRequest && this.state.roomStatus.consultRequest.doctorId}
            consultRequest={this.state.roomStatus && this.state.roomStatus.consultRequest}
            openSnackbar={this.openSnackbar}
            showProfile={true}
            profileImage={this.state.profileImage}
            makeVoiceCall={this.makeVoiceCall}
            roomId={this.state.room_id} makeVideoCall={() => this.Calling.show()}
            title={this.state.title} showMenu={this.showModalMenu} desc='مشاوره اختصاصی با دکتر ملک زاده'
          />
          <SnackBar ref={el => { this.SnackBar = el }}></SnackBar>
          {this.state.menus && this.state.menus.length > 0 &&
            <ModalMenu menus={this.state.menus} ref={(ref) => { this.modalMenu = ref }}></ModalMenu>
          }
          {
            this.state.initLoading ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <Loading />
              </div>
            ) : (
              <div class="chatContainer"
                onScroll={this.handleScroll}

              >
                <div class="psudo" ref="psudo" >
                  <div style={{ float: "left", clear: "both" }}
                    ref={(el) => { this.messagesEnd = el; }}>
                  </div>

                  {/* final diagnosis */}
                  {this.state.roomStatus && this.state.roomStatus.consultRequest && this.state.roomStatus.consultRequest.finalDiagnosis &&
                    <div class="MessageRow" key={this.state.roomStatus.consultRequest.id + 'ddx'}>
                      <span style={{ alignSelf: 'center' }}>تشخیص نهایی پزشک</span>
                      <TextMessage text={this.state.roomStatus.consultRequest.finalDiagnosis} me={null} time={this.state.roomStatus.consultRequest.updatedAt}></TextMessage>
                    </div>
                  }

                  {this.humanDateGlobal = null}
                  {/* room's conversations */}
                  {this.state.imageLoading &&
                    <div class="MessageRow" key={this.state.roomStatus.consultRequest.id + 'ddx'}>
                      <ImageMessage me loadingMessage />
                    </div>
                  }
                  {this.state.data.map((data, index) => <React.Fragment key={data.getId()}>{this.renderItem(data, index)}</React.Fragment>)}

                  {/* user's question */}
                  {(!this.state.hasMore || !this.state.hasScroll) &&
                    this.state.roomStatus && this.state.roomStatus.consultRequest && this.state.roomStatus.consultRequest.question &&
                    <div class="MessageRow" key={this.state.roomStatus.consultRequest.id}>
                      <TextMessage text={this.state.roomStatus.consultRequest.question} me={true} time={this.state.roomStatus.consultRequest.createdAt}></TextMessage>
                    </div>
                  }

                  {this.state.loading ? <Loading></Loading> : null}

                </div>
              </div>
            )
          }

          <React.Fragment>
            <div class="chatFooter">

              {this.state.roomStatus && this.state.roomStatus.status === 'closed' &&
                <div style={{ textAlign: 'center', flexGrow: 1, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  {!this.state.roomStatus.roomConversationRate &&
                    <>
                      <div>مکالمه پایان یافته است</div>
                      <div style={{ fontSize: '18px', fontWeight: 700 }} onClick={() => { this.modalRater.openModal() }}>
                        <span style={{ background: '#1dc37e', borderRadius: '4px', padding: '0 15px', display: 'inline-block', color: '#fff' }}>
                          ثبت میزان رضایتمندی
                      </span>
                      </div>
                    </>
                  }
                  {this.state.roomStatus.roomConversationRate &&
                    <>
                      <div style={{ marginBottom: -5 }}>میزان رضایتمندی شما</div>
                      <StarRatingComponent
                        name="userRate"
                        editing={false}
                        starColor={'#1dc37e'}
                        emptyStarColor={'#ccc'}
                        renderStarIcon={() => <StarRoundedIcon style={{ fontSize: '40px' }}></StarRoundedIcon>}
                        starCount={5}
                        value={parseInt(this.state.roomStatus.roomConversationRate.rate)}
                      />
                    </>
                  }
                </div>
              }
              {/*<Add/>
                        <Mic/>*/}
              {this.state.roomStatus && this.state.roomStatus.status === 'open' && !this.state.recording &&
                (<div class="text-message" >
                  {/* {this.state.roomStatus && this.state.roomStatus.status==='open'&& <LockRoundedIcon style={{ marginRight: 8 }} fontSize='small' onClick={() => { this.modalLockRoom.openModal() }} />} */}
                  <div class='attach'>
                    <label htmlFor="file-upload" class="attach-media-label">
                      <AttachFileRoundedIcon style={{ margin: '0 5px' }} >
                      </AttachFileRoundedIcon>
                    </label>

                    <input id="file-upload" type="file" onChange={this.onChangeHandler} accept="image/jpeg, image/jpg, image/png, video/*, .pdf" />
                  </div>

                  <MicRoundedIcon onClick={() => this.voiceBtnAction()}></MicRoundedIcon>
                  <div class="chatInputWrapper"><textarea rows="1" class="chatInput" size="sm" placeholder="ارسال پیام..." onChange={this.onTextInputHandle} ref='textInput' autoComplete="off" autoCorrect="off" spellCheck="false" /></div>
                  <SendIcon style={{ marginLeft: 5 }} onClick={() => this.sendBtn()} />
                </div>)
              }
              {this.state.roomStatus && this.state.roomStatus.status === 'open' && this.state.recording &&
                (<div class='text-message audio'>
                  {!this.state.uploadAudioLoading &&
                    <>
                      <div class='send-voice' onClick={() => this.sendRecording()}><CheckCircleOutlineRoundedIcon ></CheckCircleOutlineRoundedIcon></div>
                      <div class="time">

                        <FiberManualRecordRoundedIcon className='blink'></FiberManualRecordRoundedIcon>

                        <div class='timer'>{this.humanReadable(this.state.secondRecorded)}</div>
                      </div>
                      <div class='delete-voice' onClick={() => this.deleteRecording()}><DeleteRoundedIcon ></DeleteRoundedIcon></div>
                    </>
                  }
                  {this.state.uploadAudioLoading && <Loading />}
                </div>)
              }
            </div>
          </React.Fragment>
          <ModalImageViewer ref={(el) => { this.modalImageViewer = el }}></ModalImageViewer>
          <ModalRater ref={(el) => { this.modalRater = el }} onSubmitRate={this.onSubmitRate}></ModalRater>
          <ModalLockRoom ref={(el) => { this.modalLockRoom = el }} />

          {/* <ModalLockRoom ref={(el) => { this.modalLockRoom = el }} onLockRoom={this.onLockRoom}></ModalLockRoom> */}
        </div>
      </React.Fragment>
    )
  }
}
